<template>
  <div class="caliper-wrap">
    <div
      class="caliper relative-position"
      :style="{
        width: CALIPER_WIDTH + 'px',
        height: CALIPER_HEIGHT + 'px',
      }"
    >
      <q-img
        :src="卡钳透明背景"
        spinner-color="white"
        fit="contain"
        :style="{
          width: IMG_WIDTH + 'px',
          height: IMG_HEIGHT + 'px',
        }"
      />
      <!-- 刹车盘 -->
      <q-img
        :src="卡钳盘片"
        spinner-color="white"
        class="absolute"
        fit="fill"
        :style="{
          width: BRAKE_DISK_WIDTH + 'px',
          height: BRAKE_DISK_HEIGHT + 'px',
          left: 55 + 51 + 'px',
          top: CALIPER_HEIGHT / 2 - 20 + 'px',
          zIndex: 10,
          overflow: 'visible',
        }"
      />
      <!-- <div
        class="brake-disk bg-grey absolute"
        :style="{
          width: BRAKE_DISK_WIDTH + 'px',
          height: BRAKE_DISK_HEIGHT + 'px',
          left: 55 + 55 + 'px',
          top: CALIPER_HEIGHT / 2 - 20 + 'px',
          zIndex: 10,
          overflow: 'visible',
        }"
      >
        <div
          class="trapezoid absolute-center"
          :style="{
            left: BRAKE_DISK_WIDTH + 10 + 'px',
            zIndex: 10,
          }"
        ></div>
      </div> -->
      <!-- 左侧刹车 (移动) -->
      <div
        class="caliper-left full-height absolute"
        :style="{
          left: 55 + caliperInterval + 'px',
          top: '95px',
          zIndex: 10,
          width: '30px',
        }"
      >
        <q-img :src="刹车片左" spinner-color="white" fit="contain" />
      </div>
    </div>
    <!-- 右侧刹车 （固定） -->
    <div class="caliper-right full-height absolute">
      <!-- 刹车组合 (移动) -->
      <div
        class="breke-block-group absolute row items-center"
        :style="{
          left: 155 - caliperInterval + 'px',
          top: '-222px',
          zIndex: 10,
          width: '135px',
        }"
      >
        <q-img :src="刹车片右" spinner-color="white" fit="contain" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
// import { btnToggleOptions } from "../../helper/ada";
import 刹车片左 from "@/assets/img/刹车片左.png";
import 刹车片右 from "@/assets/img/刹车片右.png";
import 卡钳透明背景 from "@/assets/img/卡钳透明背景3.png";
// import 卡钳盘片 from "@/assets/img/卡钳盘片.png";
import 卡钳盘片 from "@/assets/img/卡钳盘片2.png";
import { limitUIRx_BrakeAirGap } from "../../helper/ada";
const CALIPER_WIDTH = 420;
const CALIPER_HEIGHT = 300;
const IMG_HEIGHT = 300;
const IMG_RATE = IMG_HEIGHT / CALIPER_HEIGHT;
const IMG_WIDTH = 420 * IMG_RATE;
const BRAKE_DISK_RATE = 81 / 655;
const BRAKE_DISK_WIDTH = 40;
const BRAKE_DISK_HEIGHT = BRAKE_DISK_WIDTH / BRAKE_DISK_RATE;
interface Props {
  value: any; // 0 - .5
}
const props = withDefaults(defineProps<Props>(), {
  value: 0,
});

const caliperInterval = computed(() => {
  const value = limitUIRx_BrakeAirGap(props.value);
  return 20 - value * 2 * 20;
});

// const caliperInterval = computed(() => {
//   const item = btnToggleOptions.find((item) => item.value === props.value);
//   if (!item) return 0;
//   return item.interval;
// });
// 计算齿轮的旋转角度
// const gearRotation = computed(() => {
//   const deg = 60 * props.value;
//   return deg;
// });
</script>
<style scoped lang="scss">
.spring {
  background-image: url(/src/assets/img/弹簧_横向.png);
  background-size: 100% 100%;
  background-position: center;
}
.m-core {
  border: 2px solid #000;
  font-size: 20px;
}
.trapezoid {
  width: 0;
  height: 150px;
  border: 10px solid transparent;
  border-left-color: #9e9e9e;
}
.animated {
  transition: transform 0.5s ease-in-out, left 0.5s ease-in-out; // 添加过渡效果
}
</style>
